import React, {useState, useEffect} from 'react';

// material components
import {
    TextField
} from "@material-ui/core";

//constants

import styles from "./CreateMarketplaceDialog.module.css";
import PropTypes from "prop-types";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InfoIcon from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";

function PickUpOrderTagSetting(props) {
    return(
        <div className={styles.rowSelects}>
            <div>
                <div className={styles.rowSpec}>
                    <div className={styles.formText}>
                        Apply
                    </div>
                    <div className={styles.formSelect}>
                        <Autocomplete
                            options={props.tags.map((tag) => {return tag.tagName})}
                            getOptionLabel={(marketplace) => marketplace}
                            name="tagForPickupOrder"
                            onChange={(event, value) => {
                                const selectedTag = props.tags.find(
                                    tag => tag.tagName === value
                                );
                                if (selectedTag) {
                                    props.handleTagChange(selectedTag.tagId)
                                }
                                else{
                                    props.handleTagChange(null)
                                }
                            }}

                            value={props.tags.find( tag => tag.tagId === props.parentState.tagForPickupOrder)?.tagName || ""}
                            className={styles.formInput + " " + styles.formSelect}
                            blurOnSelect={true}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Tag"
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name="tagForPickupOrder"
                                />
                            }
                        />
                    </div>

                    <div className={styles.formText}>
                      to pickup orders

                        <Tooltip className={styles.formInfoIcon}
                            title="This will also apply the tag when importing orders manually">
                            <InfoIcon  style={{ color: 'gray' }} />
                        </Tooltip>
                    </div>
                </div>
            </div>
        </div>
    )
}

PickUpOrderTagSetting.propTypes = {
    handleTagChange: PropTypes.func,
    parentState: PropTypes.object,
    errors: PropTypes.array,
    isEdit: PropTypes.bool
}

PickUpOrderTagSetting.defaultProps = {

    parentState: {},
    errors: [],
    isEdit: false
}

export default PickUpOrderTagSetting